import request from '../utils/request';

// 展商活动列表;
export function getLists(data) {
  return request({
    url: '/frontExhibitor/activity/list',
    method: 'get',
    params: data,
  });
}

// 新增活动
export function addLive(data) {
  return request({
    url: '/frontExhibitor/activity/saveOrEdit',
    method: 'POST',
    data: data,
  });
}

// \修改排序
export function updateSort(data) {
  return request({
    url: '/frontExhibitor/activity/editSort',
    method: 'get',
    params: data,
  });
}

// 展商活动审核统计
export function countAudit() {
  return request({
    url: '/frontExhibitor/activity/countAudit',
    method: 'get',
  });
}

// 获取单个活动的信息
export function getActive(data) {
  return request({
    url: '/frontExhibitor/activity/view',
    method: 'get',
    params: data,
  });
}

// 编辑单个活动信息
export function editLive(data) {
  return request({
    url: '/frontExhibitor/activity/saveOrEdit',
    method: 'POST',
    data: data,
  });
}

// 删除活动信息
export function delItem(data) {
  return request({
    url: '/frontExhibitor/activity/delete',
    method: 'get',
    params: data,
  });
}
